import { useEffect, useState } from "react";

type MediaWidthClasses = "sm" | "md" | "lg" | "xl";
type MediaWidthList = Record<MediaWidthClasses, number>;

export const MEDIA_WIDTHS: MediaWidthList = {
  sm: 576,
  md: 768,
  lg: 882,
  xl: 1200,
};

export const useMediaQuery = (size: MediaWidthClasses) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const query = `(max-width: ${MEDIA_WIDTHS[size]}px)`;
    const media = window.matchMedia(query);
    setMatches(media.matches);
    const listener = () => setMatches(window.matchMedia(query).matches);
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
  }, [size]);

  return matches;
};
